module.exports = __webpack_public_path__ + "static/media/4ODA14.c8fe7311.jpg";